(function() {
  'use strict';

  // WhatsApp APP Detection and Navigation
  function initWhatsAppNavigation() {
    const whatsappLinks = document.querySelectorAll('.mobile-nav-whatsapp');
    
    whatsappLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const url = this.getAttribute('data-whatsapp-url') || this.getAttribute('href');
        if (!url) return;

        // Check if device is mobile
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
          // Extract phone number from URL if it's a wa.me link
          let phoneNumber = '';
          if (url.includes('wa.me/')) {
            phoneNumber = url.split('wa.me/')[1].split('?')[0];
          }
          
          // For iOS, try to open WhatsApp app first
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            if (phoneNumber) {
              // Try WhatsApp app URL scheme
              const appUrl = 'whatsapp://send?phone=' + phoneNumber;
              
              // Try to open the app
              window.location.href = appUrl;
              
              // Fallback: if app doesn't open, the browser will handle the original URL
              // Set a timeout to open web version if app doesn't respond
              setTimeout(function() {
                // Only open web if we're still on the page (app didn't take over)
                if (document.hasFocus && document.hasFocus()) {
                  window.open(url, '_blank');
                }
              }, 2500);
              
              e.preventDefault();
              return false;
            }
          }
          
          // For Android, wa.me links should automatically open the app if installed
          // If app is not installed, it will open in browser
          // No need to prevent default, let the link work naturally
        } else {
          // Desktop: open in new tab
          this.setAttribute('target', '_blank');
        }
      });
    });
  }

  // WeChat QR Code Modal
  function initWeChatQRModal() {
    const wechatBtn = document.querySelector('[data-mobile-wechat-btn]');
    const modal = document.querySelector('[data-mobile-wechat-modal]');
    const closeBtns = document.querySelectorAll('[data-mobile-wechat-close]');
    const saveBtn = document.querySelector('[data-mobile-wechat-save]');
    const qrImage = document.getElementById('mobile-wechat-qr-image');

    if (!wechatBtn || !modal) return;

    // Open modal
    wechatBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });

    // Close modal
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = ''; // Restore scrolling
    }

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    });

    // Close on overlay click
    const overlay = modal.querySelector('.mobile-wechat-qr-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeModal();
        }
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    // Save QR Code
    if (saveBtn && qrImage) {
      saveBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        try {
          // Get the image source
          const imgSrc = qrImage.src;
          
          // Create a temporary link element
          const link = document.createElement('a');
          link.href = imgSrc;
          link.download = 'wechat-qr-code.jpg'; // Default filename
          link.target = '_blank';
          
          // For iOS Safari, we need to open in new window first
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            // Open image in new window for user to save manually
            window.open(imgSrc, '_blank');
            
            // Show a message to user
            if (window.confirm) {
              alert('Please long-press the image and select "Save Image" to save the QR code.');
            }
          } else {
            // For other browsers, try to download directly
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } catch (error) {
          console.error('Error saving QR code:', error);
          // Fallback: open image in new tab
          if (qrImage) {
            window.open(qrImage.src, '_blank');
          }
        }
      });
    }
  }

  // Initialize on DOM ready
  function init() {
    initWhatsAppNavigation();
    initWeChatQRModal();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify theme editor section load
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      init();
    });
  }
})();
